import { useEffect, useRef } from "react";
import { useProgramsInvalidator } from "./programsInvalidator";

// Leaving the surface with the program editor open is a way out too (#434):
// Save keeps the editor open, so onSaved/onCancel may never run. Web and
// mobile (editorOpen always true there) both send it through this hook.
export function useProgramsChangedOnUnmount(editorOpen: boolean): void {
  const invalidator = useProgramsInvalidator();
  const openRef = useRef(editorOpen);
  openRef.current = editorOpen;
  useEffect(
    () => () => {
      if (openRef.current) invalidator?.invalidate();
    },
    [invalidator],
  );
}
